import React from "react";
export const WarehouseAllocationDetailContext = React.createContext(null);
export const useWarehouseAllocationDetailContext = () => {
  const context = React.useContext(WarehouseAllocationDetailContext);
  if (!context) throw new Error("Warehouse Allocation context not provided!");
  return context;
};
